'use client'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import TorHeader from 'components/TorHeader'
import SecNav from 'components/SecNav'
import { ONE } from 'config/apis'
import { dateToString } from 'utils/date'
import { capitalizeString } from 'utils/strings'
import { useTorContext } from 'utils/context'

const Layout = ({ children }) => {
  const { tor, setTor, torDetails } = useTorContext()
  const pathname = usePathname()
  const [slugYear, slugTor] = pathname
    .replace(torDetails.torUrl, '')
    .split('/')
    .filter((e) => e)
    .slice(0, 2)
  const torUrl = `${torDetails.torUrl}/${slugYear}/${slugTor}`
  // const today = new Date()

  const getData = async () => {
    try {
      const res = await fetch(
        ONE.TOR_INFO.replace('{year}', slugYear).replace('{slug}', slugTor),
        ONE.HEADERS
      )
      const parsed = await res.json()
      setTor(parsed.Data)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    tor && (
      <>
        <TorHeader
          key="0"
          title={capitalizeString(tor.Info.Name.split(' - ')[0])}
          details={`${
            tor?.Categories?.[0]?.Place
              ? `${capitalizeString(tor.Categories[0].Place)} `
              : ''
          }${dateToString(tor.Info.StartDate).withYear} - ${
            dateToString(tor.Info.EndDate).withYear
          }`}
          img={torDetails.cardImg}
          color={torDetails.color}
        />
        {tor && (
          <SecNav
            subsec
            items={[
              {
                name: 'Informació',
                link: `${torUrl}/informacio`,
                selected: true
              },
              // tor.Info.Type === 'EQUIPOS' && {
              //   name: 'Alineació Online',
              //   link: `${torUrl}/alineacio-online`
              // },
              tor.Info.Type === 'EQUIPOS' && {
                name: 'Veure Alineacions',
                link: `${torUrl}/veure-alineacions`
              },
              {
                name: 'Inscrits',
                link: `${torUrl}/inscrits`
              },
              // torUrl.includes(
              //   '/2025/campionat-de-catalunya-per-equips-1-categoria-x7-indoor-padel-sabadell'
              // ) && {
              //   name: 'Marcadors',
              //   link: `${torUrl}/marcadors`
              // },
              tor.Info.Type !== 'EQUIPOS' &&
                !tor.Info.inscriptionClosed && {
                  name: 'Inscriu-te',
                  link: `/privat/federat/competicio/inscripcio/${slugTor}`
                },
              {
                name: 'Horaris i Resultats',
                link: `${torUrl}/horaris-i-resultats`
              },
              {
                name: 'Quadres',
                link: `${torUrl}/quadres`
              },
              {
                name: 'Coachs',
                link: `${torUrl}/coachs`
              },
              tor.Info.Type === 'EQUIPOS' && {
                name: "Formulari d'Inscripció",
                link: `${torUrl}/formulari-dinscripcio`
              }
            ].filter((i) => i)}
            bg="sec-grey-4"
          />
        )}
        <div className="mx-4 lg:mx-0 my-10 lg:my-20">{children}</div>
      </>
    )
  )
}

export default Layout
